import { createSlice } from '@reduxjs/toolkit';

export const certificatedetailSlice = createSlice({
  name: 'certificatedetails',
  initialState: {
    data: [],
  },
  reducers: {
    setCertificate: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCertificate } = certificatedetailSlice.actions;

export const selectCertificate = (state) => state.certificatedetails.data;

export default certificatedetailSlice.reducer;
